import PropTypes from 'prop-types';

/**
 * # BaseButton
 * Component that wraps the base of the used buttons. Define a div that wraps the button component.
 * Depending of the defined props the button will render an <a> tag or a <div> with the given styles.
 * @component BaseButton
 * @param {string} buttonClass - Css class that defines the styles of the button component.
 * Properties like color, width and height, will passed through this prop.
 * @param {string} divClass - Css Class that defines the properties of the parent div that wraps the button.
 * Properties like wrapper width and position will passed through this prop.
 * @param {Node} endIcon - Icon that will be placed on the button to the right side of the button label.
 * @param {string} href - Properties that receives the <a> tag href property, when is passed by the props the button will be an <a> tag.
 * @param {string} label - Value of the button Label to be show.
 * @param {function} onClick - function triggered when the user press the button when the href prop is not defined.
 * @param {object} propsButton - Object with extra button properties.
 * @param {Node} startIcon - Icon that will be placed on the button to the left side of the button label.
 * @returns
 */
const BaseButton = ({
    buttonClass,
    divClass,
    endIcon,
    href,
    label,
    onClick,
    propsButton,
    startIcon
}) => {
    const pattern = /&#\d+;/;
    const containUnicode = pattern.test(label);
    return (
        <div className={divClass}>
            {href ?
                <a
                    href={href}
                    target="_blank"
                    rel="noreferrer"
                    className={buttonClass}
                    {...propsButton}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            flexWrap: 'nowrap',
                            alignItems: 'center',
                            gap: 5
                        }}
                    >
                        {startIcon}
                        {containUnicode ?
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignContent: 'center'
                                }}
                                dangerouslySetInnerHTML={{ __html: label }}
                            ></div> :
                            label }
                        {endIcon}
                    </div>
                </a> :
                <div onClick={onClick} className={buttonClass} {...propsButton}>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            flexWrap: 'nowrap',
                            alignItems: 'center',
                            gap: 5
                        }}
                    >
                        {startIcon}
                        {label}
                        {endIcon}
                    </div>
                </div>
            }
        </div>
    );
};

BaseButton.propTypes = {
    buttonClass: PropTypes.string.isRequired,
    divClass: PropTypes.string.isRequired,
    endIcon: PropTypes.element,
    href: PropTypes.string,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    propsButton: PropTypes.object,
    startIcon: PropTypes.element
};

export default BaseButton;
